import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { listAgents } from '@/lib/api'
import type { Agent } from '@/types'
import { Card, CardGrid } from '@/components/ui/Card'
import { StatusDot } from '@/components/ui/StatusDot'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function Overview() {
  const [agents, setAgents] = useState<Agent[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    listAgents().then((data) => {
      setAgents(data)
      setLoading(false)
    })
  }, [])

  const active = agents.filter((a) => a.status === 'active').length
  const totalBudget = agents.reduce((sum, a) => sum + (a.monthly_budget_usd ?? 0), 0)

  return (
    <div>
      <PendingBackendNotice endpoint="GET /agents" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 4 }}>Overview</h1>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 24 }}>
        Estado general de los agentes de IT AI Agents
      </p>

      <div style={{ display: 'flex', gap: 16, marginBottom: 32 }}>
        <Card style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Agentes activos</div>
          <div style={{ fontSize: 28, fontWeight: 500 }}>{loading ? '—' : active}</div>
        </Card>
        <Card style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Total agentes</div>
          <div style={{ fontSize: 28, fontWeight: 500 }}>{loading ? '—' : agents.length}</div>
        </Card>
        <Card style={{ flex: 1 }}>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Presupuesto mensual</div>
          <div className="mono" style={{ fontSize: 28, fontWeight: 500, color: 'var(--text-primary)' }}>
            ${loading ? '—' : totalBudget.toFixed(0)}
          </div>
        </Card>
      </div>

      <h2 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12, color: 'var(--text-secondary)' }}>Agentes</h2>
      <CardGrid>
        {agents.map((agent) => (
          <Link key={agent.id} to={`/agents/${agent.id}`}>
            <Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{agent.name}</div>
                <StatusDot status={agent.status} showLabel={false} />
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>
                {agent.description}
              </div>
              <div className="mono" style={{ fontSize: 11 }}>{agent.id}</div>
            </Card>
          </Link>
        ))}
      </CardGrid>
    </div>
  )
}
